import React, { useEffect } from "react";

import { Container, Content, Title, Lista, Opcoes } from "./styles";

import { withRouter } from "react-router-dom";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../services/auth";

const Webserie = () => {
  useEffect(() => {
    loadAuth();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Title>Gerencimento de Lives</Title>
          <Lista>
            <Opcoes
              onClick={() => window.open("/admin/webserie-episodio", "_self")}
            >
              Episódios
            </Opcoes>
            <Opcoes
              onClick={() => window.open("/admin/webserie-playlist", "_self")}
            >
              Playlists
            </Opcoes>
            <Opcoes
              onClick={() =>
                window.open("/admin/webserie-colaborador", "_self")
              }
            >
              Colaboradores
            </Opcoes>
          </Lista>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(Webserie);
